import { useDispatch, useSelector } from 'react-redux';

import { loaderDisplayed } from 'actions/loaderDisplayed';
import { loaderHidden } from 'actions/loaderHidden';

import { pageLoaderTypes } from 'consts/pageLoaderTypeConsts';

import { selectPageLoaderLoaderType } from 'selectors/pageLoader';

const usePageLoaders = () => {
  const dispatch = useDispatch();
  const pageLoaderType = useSelector(selectPageLoaderLoaderType);

  const hidePageLoaders = () => {
    const { animationLength = 0 } = pageLoaderType || {};

    if (animationLength) {
      // Ensure the animation has been showing for a minimum amount of time
      setTimeout(() => dispatch(loaderHidden()), animationLength);
    } else {
      dispatch(loaderHidden());
    }
  };

  const showPageLoaders = (loader = pageLoaderTypes.DEFAULT) => {
    dispatch(loaderDisplayed({ loaderType: loader }));
  };

  return { hidePageLoaders, showPageLoaders };
};

export default usePageLoaders;
